import React from 'react';
import OnOffSwitch from '../on_off_switch.jsx';
import utils from '../../utils';
import Tags from './control_panel/tags.jsx';

/*eslint no-var: [2] */

import PropTypes from 'prop-types';

import R from 'ramda';

// TODO figure out if we need code splitting on this again
import $ from 'jquery';

let nextId = 0;

class Student extends React.PureComponent {
    static displayName = 'Student';

    static propTypes = {
        checked: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    state = {
        id: 'student-' + nextId++,
    };

    render() {
        const { id } = this.state;
        const { name, checked } = this.props;

        return (
            <li>
                <label htmlFor={id}>{name}</label>
                <input
                    type="checkbox"
                    id={id}
                    className="js-sharing-checkbox"
                    checked={checked}
                    onChange={this.props.onChange}
                />
            </li>
        );
    }
}

const renderPageOptions = R.compose(
    R.prepend(
        <option key={-1} value="-1">
            All Pages
        </option>
    ),
    R.map(([pagenum, label]) => {
        return (
            <option key={pagenum} value={pagenum}>
                Page {label}
            </option>
        );
    }),
    // Object keys are always strings, but we need numbers for sorting
    R.sortBy(([pagenum, label]) => parseInt(pagenum, 10)),
    R.toPairs
);

class NotesControlPanel extends React.PureComponent {
    static displayName = 'NotesControlPanel';

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleVisibility: PropTypes.func.isRequired,
        closeControlPanel: PropTypes.func.isRequired,
        addTag: PropTypes.func.isRequired,
        setPage: PropTypes.func.isRequired,
        removeTag: PropTypes.func.isRequired,
        allClassmates: PropTypes.object,
        allInstructors: PropTypes.array,
        allPages: PropTypes.object,
        allTags: PropTypes.array,
        currentUserURI: PropTypes.string.isRequired,
        includeClassmate: PropTypes.func.isRequired,
        isInstructor: PropTypes.bool.isRequired,
        analyticsEvent: PropTypes.func.isRequired,
        onlyPage: PropTypes.oneOfType([
            PropTypes.string,
            // This gets converted to a string below. This whole page
            // selection is a little awkward.
            PropTypes.number,
        ]).isRequired,

        questions: PropTypes.bool.isRequired,
        selectedTags: PropTypes.array,
        showSelectedClassmates: PropTypes.array,
        slug: PropTypes.string.isRequired,
        unansweredQuestions: PropTypes.bool.isRequired,
        toggleUnansweredQuestions: PropTypes.func.isRequired,
        toggleQuestions: PropTypes.func.isRequired,
        hideSharingQA: PropTypes.bool.isRequired,
        addAural: PropTypes.func.isRequired,
    };

    state = {
        students: [],
    };

    tags = React.createRef();

    componentWillUnmount() {
        this.props.closeControlPanel();
    }

    getShowMine = () => {
        const { showSelectedClassmates, currentUserURI } = this.props;
        return R.contains(currentUserURI, showSelectedClassmates);
    };

    toggleMine = () => {
        const { currentUserURI, includeClassmate, addAural } = this.props;
        const show = !this.getShowMine();
        includeClassmate(currentUserURI, show);
        addAural(`${show ? 'show' : 'hid'}ing your notes`);
    };

    getShowInstructors = () => {
        const { showSelectedClassmates, allInstructors } = this.props;
        return (
            R.intersection(allInstructors, showSelectedClassmates).length > 0
        );
    };

    toggleInstructors = () => {
        const { allInstructors, includeClassmate, addAural } = this.props;
        const show = !this.getShowInstructors();
        includeClassmate(allInstructors, show);
        addAural(`${show ? 'show' : 'hid'}ing instructor notes`);
    };

    areAllUsersSelected = () => {
        const { allClassmates, showSelectedClassmates } = this.props;
        return showSelectedClassmates.length == R.keys(allClassmates).length;
    };

    toggleAll = e => {
        e.preventDefault();
        const { allClassmates, includeClassmate, addAural } = this.props;
        const show = !this.areAllUsersSelected();

        includeClassmate(R.keys(allClassmates), show);
        addAural(`${show ? 'show' : 'hid'}ing all classmates`);
    };

    toggleQuestions = e => {
        e.preventDefault();
        const { questions, toggleQuestions, addAural } = this.props;
        toggleQuestions();
        addAural(`${questions ? 'hid' : 'show'}ing questions`);
    };

    toggleUnansweredQuestions = () => {
        const {
            unansweredQuestions,
            toggleUnansweredQuestions,
            addAural,
        } = this.props;
        toggleUnansweredQuestions();
        addAural(
            `${unansweredQuestions ? 'hid' : 'show'}ing unanswered questions`
        );
    };

    onSubmit = e => {
        e.preventDefault();
        this.tags.current.onSubmit();
    };

    printNotes = e => {
        e.preventDefault();
        window.print();
    };

    getExportUrl = () => {
        const { slug, selectedTags, onlyPage } = this.props;
        const showMine = this.getShowMine();
        const showInstructors = this.getShowInstructors();

        const params = {
            format: 'csv',
            slug: slug,
            instructor: showInstructors,
            mine: showMine,
            limit: 500,
        };
        if (onlyPage > 0) {
            params.showPage = onlyPage;
        }
        if (selectedTags.length) {
            params.showTags = selectedTags.join(',');
        }

        return '/api/v3/note/?' + $.param(params);
    };

    trackDownload = () => {
        this.props.analyticsEvent('notes-csv', 'download');
    };

    handlePageSelect = event => {
        this.props.setPage(event.target.value);
    };

    renderStudents = () => {
        const { allClassmates, showSelectedClassmates } = this.props;
        if (allClassmates.length === 0) {
            return null;
        }

        const students = R.map(([resource_uri, name]) => {
            const onChange = e => {
                this.props.includeClassmate(resource_uri, e.target.checked);
            };

            const checked = R.contains(resource_uri, showSelectedClassmates);

            return (
                <Student
                    key={resource_uri}
                    resource_uri={resource_uri}
                    name={name}
                    checked={checked}
                    withAll={null}
                    onChange={onChange}
                />
            );
        }, R.toPairs(allClassmates));

        const toggleLabel = this.areAllUsersSelected() ? 'None' : 'All';
        return (
            <fieldset className="settings-students">
                <legend className="toggle-container">
                    <span id="class-memeber-filter-label">
                        Select class members:
                    </span>
                    <button
                        aria-live="polite"
                        aria-describedby="class-member-filter-label"
                        className="toggle-students"
                        onClick={this.toggleAll}
                        onKeyDown={utils.ifSpace(this.toggleAll)}
                    >
                        {toggleLabel}
                    </button>
                </legend>
                <div className="well">
                    <ul className="students-list">{students}</ul>
                </div>
            </fieldset>
        );
    };

    renderPagesFieldset = () => {
        const { allPages } = this.props;

        return (
            <fieldset className="pages">
                <legend className="aural" id="page-selector-legend">
                    Page selection list
                </legend>
                <select
                    onChange={this.handlePageSelect}
                    aria-labelledby="page-selector-legend"
                >
                    {renderPageOptions(allPages)}
                </select>
            </fieldset>
        );
    };

    renderUnansweredQuestions = () => {
        if (!this.props.isInstructor) {
            return null;
        }

        const { unansweredQuestions } = this.props;
        return (
            <div className="filter-control">
                <OnOffSwitch
                    onChange={this.toggleUnansweredQuestions}
                    checked={unansweredQuestions}
                    disabled={false}
                    className="pull-right"
                >
                    <span className="aural">Show:</span>
                    Unanswered
                </OnOffSwitch>
            </div>
        );
    };

    render() {
        const {
            allClassmates,
            currentUserURI,
            allInstructors,
            questions,
            isOpen,
            hideSharingQA,
        } = this.props;
        const classmatesSet = R.keys(allClassmates);
        const showMine = this.getShowMine();
        const showInstructors = this.getShowInstructors();

        const disableInstructors =
            R.intersection(allInstructors, classmatesSet).length === 0;
        const disableMine = !R.contains(currentUserURI, classmatesSet);
        const visibleClass = isOpen ? 'aside open' : 'aside closed';
        return (
            <div
                aria-label="Notes Control Panel"
                className={`notes-control-panel ${visibleClass}`}
            >
                {hideSharingQA ? null : (
                    <div>
                        <div className="header">
                            <h2>Filters</h2>
                            <button onClick={this.props.toggleVisibility}>
                                Done
                                <span className="aural">Hide filter panel</span>
                            </button>
                        </div>
                        <form onSubmit={this.onSubmit}>
                            {this.renderPagesFieldset()}
                            <fieldset>
                                <legend className="aural">
                                    Hide or Show Notes by Type
                                </legend>
                                <div className="filter-control">
                                    <OnOffSwitch
                                        onChange={this.toggleMine}
                                        checked={showMine || disableMine}
                                        disabled={disableMine}
                                        className="pull-right"
                                    >
                                        <span className="aural">Show:</span>
                                        My Notes
                                    </OnOffSwitch>
                                </div>
                                <div className="filter-control">
                                    <OnOffSwitch
                                        onChange={this.toggleInstructors}
                                        checked={
                                            showInstructors ||
                                            disableInstructors
                                        }
                                        disabled={disableInstructors}
                                        className="pull-right"
                                    >
                                        <span className="aural">Show:</span>
                                        Instructor Notes
                                    </OnOffSwitch>
                                </div>
                                <div className="filter-control">
                                    <OnOffSwitch
                                        onChange={this.toggleQuestions}
                                        checked={questions}
                                        disabled={false}
                                        className="pull-right"
                                    >
                                        <span className="aural">Show:</span>
                                        Questions
                                    </OnOffSwitch>
                                </div>
                                {this.renderUnansweredQuestions()}
                            </fieldset>
                            <Tags
                                addTag={this.props.addTag}
                                removeTag={this.props.removeTag}
                                ref={this.tags}
                                selectedTags={this.props.selectedTags}
                                allTags={this.props.allTags}
                            />
                        </form>
                        {this.renderStudents()}
                    </div>
                )}
                <div className="colophon">
                    <button
                        className="print-notes js-print-notes"
                        onClick={this.printNotes}
                        title="Print Notes"
                    >
                        <i
                            className="cl-icon cl-icon-print"
                            aria-hidden="true"
                        />
                        Print
                    </button>
                    <a
                        className="export-notes js-export-notes"
                        href={this.getExportUrl()}
                        onClick={this.trackDownload}
                        role="button"
                        target="note-download-iframe"
                        title="Export Notes"
                    >
                        <i
                            className="cl-icon cl-icon-download"
                            aria-hidden="true"
                        />
                        Export
                    </a>
                    {/*
                        Based on my search results it looks like firefox prefers
                        name and id to match on the iframe for this to work.
                        IDK if it still matters, but it doesn't seem to break
                        so... ¯\_(ツ)_/¯
                     */}
                    <iframe
                        name="note-download-iframe"
                        id="note-download-iframe"
                        style={{ display: 'none' }}
                        title="Download Note"
                    />
                </div>
            </div>
        );
    }
}

export default NotesControlPanel;



// WEBPACK FOOTER //
// ./src/components/all_notes/control_panel.jsx